import { Block, Inline } from '@contentful/rich-text-types';
import { Next, NodeRenderer } from '@contentful/rich-text-html-renderer';

export const getOlHtml = ((node: Block | Inline, next: Next) =>
  `<ol>${next(node.content)} </ol>`) as NodeRenderer;
